var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Footer-list"},[_vm._t("heading"),_c('ul',[_vm._t("links")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }